import React from 'react';

const PrivacyPolicy = () => (
  <div style={{ maxWidth: 700, margin: '2rem auto', padding: '2rem', background: '#f9f9f9', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.07)', fontSize: '0.89rem' }}>
    <h2 style={{ color: '#1976d2', marginBottom: '1.2rem' }}>Privacy Policy</h2>
    <p>
      <strong>Effective Date:</strong> March 23, 2026
    </p>
    <p>
      MangaloreHub.com values your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and services.
    </p>
    <h3>Information We Collect</h3>
    <ul>
      <li>Information you provide directly (such as name, email, phone number, and messages submitted via forms).</li>
      <li>Usage data (such as pages visited, time spent, and browser/device information).</li>
      <li>Cookies and similar technologies for analytics and site functionality.</li>
    </ul>
    <h3>How We Use Your Information</h3>
    <ul>
      <li>To provide and improve our services.</li>
      <li>To respond to your inquiries and support requests.</li>
      <li>To send you updates, newsletters, or promotional materials (if you opt in).</li>
      <li>To analyze site usage and improve user experience.</li>
    </ul>
    <h3>Information Sharing</h3>
    <p>
      We do not sell or rent your personal information. We may share information with trusted third-party service providers who assist us in operating the website, as required by law, or to protect our rights.
    </p>
    <h3>Data Security</h3>
    <p>
      We implement reasonable security measures to protect your information. However, no method of transmission over the Internet is 100% secure.
    </p>
    <h3>Your Choices</h3>
    <ul>
      <li>You may opt out of receiving marketing emails at any time.</li>
      <li>You can disable cookies in your browser settings.</li>
      <li>You may request access, correction, or deletion of your personal data by contacting us.</li>
    </ul>
    <h3>Children's Privacy</h3>
    <p>
      Our site is not intended for children under 13. We do not knowingly collect personal information from children.
    </p>
    <h3>Changes to This Policy</h3>
    <p>
      We may update this Privacy Policy from time to time. Changes will be posted on this page with a new effective date.
    </p>
    <h3>Disclaimer</h3>
    <p>
      MangaloreHub.com is a platform for connecting users with local businesses, services, and information. While we strive to provide accurate and up-to-date content, we are not responsible for the actions, content, or services of third-party providers, advertisers, or external websites linked from our platform. Users are advised to verify information and exercise discretion when engaging with any listings, advertisements, or external resources.
    </p>
    <h3>Contact Us</h3>
    <p>
      If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@mangalorehub.com">info@mangalorehub.com</a>.
    </p>
  </div>
);

export default PrivacyPolicy;
